/*
  Testimonial slider
*/

export function testimonialSlider() {

  $('.testimonials-section.slider').each(function () {
    if ($(this).find('.testimonial-wrp').children().length > 1) {
      $(this).find('.testimonial-wrp').flickity({
        pageDots: false,
        prevNextButtons: true,
        wrapAround: true,
        adaptiveHeight: true,
      });

      if (window.matchMedia('(min-width: 992px)').matches) {
        $(this).find('.flickity-button').appendTo($(this).find('.section-title-wrp'));
      } else {
        $(this).find('.flickity-button').appendTo($(this).find('.testimonial-outter-wrp .pagination-controller'));
      }
    }
  });
}